import { Routes } from '@angular/router';
import { Error404Page } from './errors/404.component';
import { AdminPage } from './admin/admin.page';
import { FeedbackComponent } from './footer/feedback.component';
import { RoomGateComponent } from './poker-room/room-gate.component';
import { CreateRoomRouteComponent } from './home/create-room-route.component';


export const appRoutes: Routes = [
    { path: 'create-room', component: CreateRoomRouteComponent, data: { id: 'create-room', noIndex: true } },
    { path: '404', component: Error404Page, data: { id: '404' } },
    { path: 'feedback', component: FeedbackComponent, data: { id: 'feedback' } },
    { path: 'admin', component: AdminPage, data: { id: 'admin' } },
    { path: 'room/:id/scrum-poker', component: RoomGateComponent, data: { id: 'room', noIndex: true } },
    { path: 'room/:id/scrum-poker-test', component: RoomGateComponent, data: { id: 'room-test', isTestMode: true, noIndex: true } },

    { path: 'room/:id/scrum-poker/:id2', component: RoomGateComponent, data: { id: 'room', noIndex: true } },
    {
        path: 'user', loadChildren: () => import('./user/user.module').then(m => m.UserModule),
        data: { id: 'user' }
    },
    { path: '**', redirectTo: '/404' },

];

// SEO metadata for remaining Angular routes (migrated pages are handled by Astro)

export const standardTitleIt = 'Scrum Poker Online - strumento gratuito per il poker di pianificazione';
export const standardDescriptionIt = 'Imposta la tua sessione di poker di pianificazione in pochi secondi. App online per impostare e gestire sessioni di planning poker.';
export const routesSEO_it = {
    '404.title': standardTitleIt + ' - Pagina non trovata',
    '404.description': standardDescriptionIt,
    'feedback.title': standardTitleIt + ' - Invia un Feedback',
    'feedback.description': 'Mandaci un feedback sulla App online di Scrum Poker. Lo strumento che richiede solo pochi secondi per impostare una sessione di planning poker.',
    'room.title': standardTitleIt,
    'room.description': standardDescriptionIt
};

export const standardTitleEn = 'Scrum Poker Online - Free Tool for Planning Poker';
export const standardDescriptionEn = 'Set up your planning poker session in seconds. Online app to collaborate and estimate in scrum poker.';
export const routesSEO_en = {
    '404.title': standardTitleEn + ' - Page Not Found',
    '404.description': standardDescriptionEn,
    'feedback.title': standardTitleEn + ' - Provide Feedback',
    'feedback.description': 'Provide feedback about Scrum Poker Online App. The tool that takes you just seconds to set-up a planning poker session.',
    'room.title': standardTitleEn,
    'room.description': standardDescriptionEn
};

export const standardTitleFr = 'Scrum Poker Online - Outil gratuit pour le planning poker';
export const standardDescriptionFr = 'Organisez votre session de planning poker en quelques secondes. Application en ligne pour collaborer et faire des estimations de scrum poker.';
export const routesSEO_fr = {
    '404.title': standardTitleFr + ' - Page non trouvée',
    '404.description': standardDescriptionFr,
    'feedback.title': standardTitleFr + ' - Fournir un feedback',
    'feedback.description': 'Donnez votre avis sur l\'application Scrum Poker. L\'outil qui vous permet d\'organiser une session de scrum poker en quelques secondes seulement.',
    'room.title': standardTitleFr,
    'room.description': standardDescriptionFr
};

export const standardTitleDe = 'Scrum Poker Online - Kostenloses Tool zum Planning Poker';
export const standardDescriptionDe = 'Richten Sie Ihre Planning Poker-Sitzung in Sekundenschnelle ein. Online-App zur Zusammenarbeit und Schätzung beim Scrum-Poker.';
export const routesSEO_de = {
    '404.title': standardTitleDe + '- Seite nicht gefunden',
    '404.description': standardDescriptionDe,
    'feedback.title': standardTitleDe + ' – Feedback geben',
    'feedback.description': 'Geben Sie Feedback zur Scrum Poker Online App. Das Tool, mit dem Sie in Sekundenschnelle eine Planning-Poker-Sitzung einrichten können.',
    'room.title': standardTitleDe,
    'room.description': standardDescriptionDe
};

export const standardTitleEs = 'Scrum Poker Online - Herramienta gratuita de planning poker';
export const standardDescriptionEs = 'Organiza tu sesión de planning poker en segundos. Aplicación en línea para colaborar y hacer estimaciones de scrum poker';
export const routesSEO_es = {
    '404.title': standardTitleEs + ' - Página no encontrada',
    '404.description': standardDescriptionEs,
    'feedback.title': standardTitleEs + ' - Dar retroalimentación',
    'feedback.description': 'Da tu opinión sobre la aplicación de Scrum Poker. La herramienta que le permite organizar una sesión de póquer de scrum en sólo unos segundos.',
    'room.title': standardTitleEs,
    'room.description': standardDescriptionEs
};

export const standardTitlePt = 'Scrum Poker Online - Free Tool for Planning Poker';
export const standardDescriptionPt = 'Set up your planning poker session in seconds. Online app to collaborate and estimate in scrum poker.';
export const routesSEO_pt = {
    '404.title': standardTitlePt + ' - Page Not Found',
    '404.description': standardDescriptionPt,
    'feedback.title': standardTitlePt + ' - Provide Feedback',
    'feedback.description': 'Provide feedback about Scrum Poker Online App. The tool that takes you just seconds to set-up a planning poker session.',
    'room.title': standardTitlePt,
    'room.description': standardDescriptionPt
};
